export default "__VITE_ASSET__BnpfnYra__"